<template>
	<div class="page">
		<el-container style="height: 100%;">
			<el-aside width="200px">
				<div class="leftTile">
					视图
				</div>
				<div class="leftList">
					<div class="item" :class="leftIndex == item.id ? 'itemActive': ''" v-for="(item,index) in leftList"
						:key="index" @click="leftIndex = item.id">
						{{item.name}}
					</div>
				</div>
			</el-aside>
			<el-container>
				<el-header height="120px">
					<div style="height: 100%;">
						<div class="topView">
							<el-icon class="el-icon-s-fold"></el-icon>
							<!-- <el-date-picker v-model="time" format="yyyy-MM-dd" type="datetimerange"
								:picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期"
								end-placeholder="结束日期" align="right">
							</el-date-picker> -->
							<el-input style="margin-left: 10px;" placeholder="请输入内容" v-model="nickname"
								class="input-with-select">
								<el-button slot="prepend" icon="el-icon-search" @click="getList()"></el-button>
								<el-button slot="append" type="info" @click="reset()">重置</el-button>
							</el-input>
						</div>
						<div class="bottomView">
							<div class="leftButton">
								<el-button type="primary">添加客户<i
										class="el-icon-arrow-down el-icon--down"></i></el-button>
								<el-button :disabled="!selection?.length">批量操作</el-button>
								<el-button>自定</el-button>
							</div>
							<div class="rightButton">
								<el-button>导出</el-button>
								<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
									:current-page="page" :page-sizes="[10, 20, 30, 40]" :page-size="10"
									layout="total,  sizes" :total="total">
								</el-pagination>
								<div class="page-wrapper">
									<el-button @click="prevPage" :disabled="page <= 1">‹</el-button>

									<div class="page-input">
										<el-input style="width: 70px;margin-right: 10px;" type="number"
											v-model.number="inputPage" @keyup.enter="jumpPage"></el-input>
										<span>/ {{ totalPage }}</span>
									</div>

									<el-button @click="nextPage" :disabled="page >= totalPage">›</el-button>
								</div>
							</div>
						</div>

					</div>
				</el-header>
				<el-main class="mainEl">
					<div class="table">
						<el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange">
							<el-table-column type="selection" min-width="55">
							</el-table-column>
							<el-table-column fixed prop="nickname" align="center" label="姓名" min-width="150">
							</el-table-column>
							<el-table-column prop="name" align="center"  label="id" min-width="120">
							</el-table-column>
							<el-table-column prop="channel_id" align="center"  label="社媒官方ID" min-width="120">
							</el-table-column>
							<el-table-column prop="customer_service_id" align="center"  label="接待会员" min-width="120">
							</el-table-column>
							<el-table-column prop="ipowner" label="地址" align="center"  width="160">
							</el-table-column>
							<!-- <el-table-column prop="address" label="邮箱" min-width="300">
							</el-table-column>
							<el-table-column prop="zip" label="手机" min-width="120">
							</el-table-column>
							<el-table-column prop="zip" label="国家/地区" min-width="120">
							</el-table-column>
							<el-table-column prop="zip" label="城市" min-width="120">
							</el-table-column>
							<el-table-column prop="zip" label="语言" min-width="120">
							</el-table-column> -->
							<el-table-column prop="status" align="center"  label="状态" min-width="80">
							</el-table-column>
							<!-- <el-table-column prop="zip" label="备注" min-width="120">
							</el-table-column> -->
							<el-table-column prop="createtime" align="center"  label="创建时间" min-width="120">
							</el-table-column>
							<el-table-column fixed="right" align="center"  label="操作" min-width="120">
								<template slot-scope="scope">
									<!-- slot-scope="scope" -->
									<!-- @click.native.prevent="deleteRow(scope.$index, tableData)" -->
									<el-button type="text" @click.native.prevent="showChatPage(scope.row,1)" size="small">
										详情
									</el-button>
									<el-button type="text"  @click.native.prevent="showChatPage(scope.row,2)" size="small">
										回聊
									</el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</el-main>
			</el-container>
		</el-container>

		<rightDrawer size="60%" :drawer="drawer" :params="drawerObj" @update:drawer="drawer = $event"></rightDrawer>
	</div>
</template>

<script>
	import rightDrawer from './components/rightDrawer'
	export default {
		components: {
			rightDrawer,
		},
		data() {
			return {
				page: 1,
				inputPage: 1,
				pageSize: 10,
				total: 40,
				totalPage: 4,
				drawer: false,
				drawerObj: {
					gIndex: 1
				},
				leftIndex: 1,
				tableData: [],
				leftList: [{
						id: 1,
						name: '全部客户'
					},
					{
						id: 2,
						name: '本地客户'
					}
				],
				nickname: '',
				pickerOptions: {
					shortcuts: [{
						text: '最近一周',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近一个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近三个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
							picker.$emit('pick', [start, end]);
						}
					}]
				},
				time: '',
				selection: []
			}
		},
		methods: {
			showChatPage(obj,type){
				if(type == 1){
					this.drawerObj = obj
					this.drawer = true
				}else{
					this.$store.dispatch('setChatInfo', obj)
					setTimeout(() => {
						this.$nav.go('/home/chat');
					}, 800)
				}
				
				// console.log(obj)
			},
			handleSelectionChange(val) {
				this.selection = val;
			},
			prevPage() {
				if (this.page > 1) this.page--
				this.inputPage = this.page
				this.getList()
			},
			nextPage() {
				if (this.page < this.totalPage) this.page++
				this.inputPage = this.page
				this.getList()
			},
			jumpPage() {
				let p = this.inputPage
				if (p < 1) p = 1
				if (p > this.totalPage) p = this.totalPage
				this.page = p
			},
			reset(){
				this.nickname =''
				this.getList()
			},
			async getList() {
				const res = await this.$axios.get(this.$apis.getUserList, {
					page: this.page,
					limit: this.pageSize,
					nickname: this.nickname
				})
				if (res.code == 1) {
					this.tableData = res.data.list
					this.total = res.data.total
					this.totalPage = Math.ceil(this.total / this.pageSize)
				}
			},
			handleSizeChange(val) {
				console.log(val)
			},
			handleCurrentChange(val) {
				console.log(val)
			},
		},
		mounted() {
			this.getList()
		}
	}
</script>

<style>
	.page {
		height: calc(100vh - 100px);
		background-color: white;
		
		.mainEl{
			padding: unset;
			
			.table{
				margin: unset;
				border-top: 1px solid #efefef;
				background-color: white;
				padding: 10px;
			}
		}
	}

	.el-aside {
		height: 100%;
		border-right: 1px solid #e7e7e7;

		.leftTile {
			padding: 18px;
			font-weight: bold;
			border-bottom: 1px solid #e7e7e7;
			color: #7a7a7a;
		}

		.leftList {
			padding: 10px 20px;
			color: #888888;
			font-size: 14px;

			.item {
				margin-bottom: 5px;
				padding-left: 5px;
				height: 30px;
				text-align: left;
				align-content: center;
				cursor: pointer;
				display: flow;
			}

			.itemActive {
				background: #d5ddfb;
				border-radius: 10px;
			}

			.item:hover {
				background: #d5ddfb;
				border-radius: 10px;
			}
		}
	}

	.el-container {
		height: 100%;
	}
	
	

	.el-header {
		/* height: 100px; */
		padding: 10px 20px;

		.topView {
			height: 50%;
			display: flex;
			align-items: center;

			.el-icon-s-fold {
				padding: 5px;
				font-size: 20px;
				color: #666666;
			}

			.el-range-separator {
				width: 13%;
			}
		}

		.bottomView {
			display: flex;
			height: 50%;
			justify-content: space-between;
			align-items: center;
			font-size: 13px;

			.rightButton {
				display: flex;
				align-items: center;

				.page-wrapper {
					display: flex;
					align-items: center;
					height: 80%;

					.page-input {
						margin: 0px 10px;
						display: flex;
						align-items: center;
					}
				}
			}

		}
	}
</style>